import { useCallback, useContext } from 'react';

import { closePopup, finalization, initialization, showPopup } from '@r1-frontend/bp42/actions';
import { BP42SubmitResult } from '@r1-frontend/bp42/actions/thunk/submit';
import { BP42Ctx } from '@r1-frontend/bp42/BP42Context';
import { BP42IncomingData } from '@r1-frontend/bp42/reducer/initialState';

import useCtxDispatch from './useCtxDispatch';

export interface BP42Callbacks {
    /**
     * Колбек для сабмита формы обратного звонка
     */
    onSubmit?(result: BP42SubmitResult): void,

    /**
     * Колбек для закрытия попапа
     */
    onClose?(): void,

    /**
     * Колбек для закрытия попапа о результате создания заявки на обратный звонок
     */
    onCloseResultPopup?(): void,
}

export type BP42HookProperties = BP42Callbacks & Partial<BP42IncomingData>;

/**
 * Хук для вызова формы обратного звонка.
 */
const useBP42PopupForm = () => {
    const dispatch = useCtxDispatch();
    const { callbacks } = useContext(BP42Ctx);

    const init = useCallback((incomingData: BP42HookProperties) => {
        dispatch(initialization(incomingData));

        if (incomingData.onSubmit && typeof incomingData.onSubmit === 'function') {
            callbacks.injectOnSubmit(incomingData.onSubmit);
        }

        if (incomingData.onClose && typeof incomingData.onClose === 'function') {
            callbacks.injectByName('onClose', incomingData.onClose);
        }

        if (incomingData.onCloseResultPopup && typeof incomingData.onCloseResultPopup === 'function') {
            callbacks.injectByName('onCloseResultPopup', incomingData.onCloseResultPopup);
        }
    }, [callbacks, dispatch]);

    const showHandler = () => {
        dispatch(showPopup());
    };

    const closeHandler = () => {
        dispatch(closePopup());
        callbacks.onClose();
        callbacks.flushCallbacks();
        dispatch(finalization());
    };

    return {
        show: showHandler,
        close: closeHandler,
        init,
    };
};

export default useBP42PopupForm;
